import api from './../lib/axios';

type LoginResponse = {
    token: string;
    role: string;
    employee?: {
        name?: string;
        barcode?: string | number;
        [key: string]: unknown;
    };
    user?: {
        name?: string;
        email?: string;
        barcode?: string | number;
        [key: string]: unknown;
    };
    [key: string]: unknown;
};

export const login = async (barcode: string, password: string): Promise<LoginResponse> => {
    const response = await api.post('/api/login', { barcode, password });
    const role = String(response.data?.role || '');
    const user = response.data?.user ?? {};
    const employee = response.data?.employee ?? {};
    const name = String(user?.name ?? employee?.name ?? '').trim();
    const email = String(user?.email ?? '').trim();
    const resolvedBarcode = String(employee?.barcode ?? user?.barcode ?? barcode ?? '').trim();

    localStorage.setItem('token', response.data.token);
    localStorage.setItem('role', role);
    localStorage.setItem('barcode', resolvedBarcode);
    localStorage.setItem('user_name', name);
    localStorage.setItem('user_email', email);
    return response.data;
};

export const logout = async () => {
    const token = localStorage.getItem('token');
    await api.post('/api/logout', {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('barcode');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
};

export const getProfile = async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/profile', {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};
